import { render } from "./MyNav.vue?vue&type=template&id=9cc02034&scoped=true"
import script from "./MyNav.vue?vue&type=script&lang=js"
export * from "./MyNav.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-9cc02034"

export default script